import React from 'react';


import Editors from './editor.js';
const SamjhaKar = () => {
	return (
		<>
			<Editors id={"samjhakarov"}/>
		</>
	);
};
export default SamjhaKar;
